import React, { Dispatch, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { LOGIN_PATH } from 'account/login/Login'
import { LOGIN_CONTROLLER_PATH } from 'account/loginController'
import { RoutePermissionsMapping } from 'account/permissions/mapping'

import getLoginUser, { User } from 'core/application/account/loginUser'
import { Permissions } from 'core/application/account/permissions'
import { sessionStore } from 'core/application/commons/localStorage'
import { AppState } from 'core/application/commons/reduxStore'

import useLoginUser from 'common/hooks/useLoginUser'
import useQueryRequest from 'common/hooks/useQueryRequest'

interface RedirectPageProps {}

const RedirectPage: React.FC<RedirectPageProps> = () => {
  let history = useHistory()
  const [currentUser] = useQueryRequest(null, () => getLoginUser(), { showErrors: false })
  const user = React.useMemo(() => currentUser ?? null, [currentUser])
  useEffect(() => {
    if (user) {
      if (!user?.permissions) history.push(LOGIN_PATH)
      else redirectBasedOnPermissions(user.permissions)
    }
  }, [currentUser])

  const redirectInternalTools = (permissions: Permissions[]) => {
    const entries = new URLSearchParams(history.location.search).entries()
    const search = Object.fromEntries(entries)
    const token = search.token

    if (token) {
      sessionStore.setSessionToken(token)
      window.open('/', '_self')
    } else
      history.push(LOGIN_CONTROLLER_PATH, {
        permissions: permissions,
      })
  }

  const redirectBasedOnPermissions = (permissions: Permissions[]) => {
    if (!permissions || permissions.length === 0) {
      history.push(LOGIN_PATH)
      return
    }

    if (permissions.length === 1) {
      redirectToFirstRoute(permissions)
    }

    if (permissions.length > 1) {
      if (!isPeoplekeepInternalUser(permissions)) {
        redirectToFirstRoute(permissions)
      } else {
        redirectInternalTools(permissions)
      }
    }
  }

  const isPeoplekeepInternalUser = (permissions: Permissions[]) => {
    return (
      permissions.includes(Permissions.AccessCsiDashboard) ||
      permissions.includes(Permissions.AccessCsiDashboard) ||
      permissions.includes(Permissions.AccessIchraDecisionTools)
    )
  }

  const redirectToFirstRoute = (permissions: Permissions[]) => {
    const route: string | undefined = RoutePermissionsMapping.get(permissions[0])
    if (route) {
      window.location.href = '' + route
    } else {
      history.push(LOGIN_PATH)
    }
  }

  return <div>redirecting...</div>
}

export default RedirectPage
